import React, { useState } from "react";
import { Box, IconButton, Tooltip } from "@material-ui/core";
import { Language as LanguageIcon } from "components/MaterialSymbol/MaterialIcons";
import { Edit as EditIcon } from "components/MaterialSymbol/MaterialIcons";
import { Settings as SettingsIcon } from "components/MaterialSymbol/MaterialIcons";
import { Archive as ArchiveIcon } from "components/MaterialSymbol/MaterialIcons";
import { CloudDownload as CloudDownloadIcon } from "components/MaterialSymbol/MaterialIcons";
import { BarChart as BarChartIcon } from "components/MaterialSymbol/MaterialIcons";
import { setDealerAndRedirect } from "helpers";
import { useConfirmationDialog } from "hooks/useConfirmationDialog";
import AdminLoginModal from "components/AdminLoginModal/AdminLoginModal";
import DealerToggleSwitch from "views/Dealers/Tabs/DealerToggleSwitch";

export default function ActionsCell({ row }) {
    const [isActive, setIsActive] = useState(row?.original?.isActive || 0);

    const domain = row?.original?.dealerDomain;
    const dealerId = row?.original?.id;

    const { openDialog, closeDialog } = useConfirmationDialog();

    const handleViewSite = () => {
        if (domain) {
            const url = domain.startsWith("http") ? domain : `https://${domain}`;
            window.open(url, "_blank", "noopener,noreferrer");
        }
    };

    const handleEditStore = () => {
        setDealerAndRedirect(dealerId, `/admin/edit-store/${dealerId}`);
    };

    const handleViewAdmin = () => {
        openDialog({
            customDialog: true,
            fullWidth: true,
            maxWidth: "xs",
            message: <AdminLoginModal />,
        });

        setTimeout(() => {
            closeDialog();
            setDealerAndRedirect(dealerId, `/admin/dealer-profile`);
        }, 2000);
    };

    return (
        <Box display="flex" alignItems="center" flexWrap="wrap">
            <Tooltip title="View Site">
                <IconButton size="small" onClick={handleViewSite}>
                    <LanguageIcon />
                </IconButton>
            </Tooltip>

            <Tooltip title="Edit Store">
                <IconButton size="small" onClick={handleEditStore}>
                    <EditIcon />
                </IconButton>
            </Tooltip>

            <Box ml={1} mr={1}>
                <DealerToggleSwitch
                    showLabels={false}
                    dealerId={dealerId}
                    isActive={isActive}
                    onStatusChange={(status) => setIsActive(status)}
                />
            </Box>

            {/*<Tooltip title="View Admin">
                <IconButton size="small" onClick={handleViewAdmin}>
                    <SettingsIcon />
                </IconButton>
            </Tooltip>

            <Tooltip title="Archive Store">
                <IconButton size="small">
                    <ArchiveIcon style={{ color: "red" }} />
                </IconButton>
            </Tooltip>

            <Tooltip title="Download Google Feed">
                <IconButton size="small" disabled>
                    <CloudDownloadIcon />
                </IconButton>
            </Tooltip>

            <Tooltip title="Dealer Sales Reports">
                <IconButton size="small" disabled>
                    <BarChartIcon />
                </IconButton>
            </Tooltip>*/}
        </Box>
    );
}
